import DistributorLayout from "@/core/layout/distributor/distributor.layout"

const DistributorPage = () => {
    return <DistributorLayout />
}

export default DistributorPage

